<template>
    <div :class="[borderClass]">
        <router-link :to="url" class="block py-3" @click="trackingProcess()">
            <div class="flex justify-between items-center">
                <div class="flex items-center">
                    <div>
                        <slot></slot>
                    </div>
                    <div class="ml-2 text-14 text-a-brown-502314">{{menuTitle}}</div>
                </div>
                <div>
                    <img class="icon-arrow" src="../../../../../assets/icon/ic-arrow-right-brown.svg">
                </div>
            </div>
        </router-link>
    </div>
</template>
<script>
export default {
    props: {
        url: { type: String, required: true },
        menuTitle: { type: String, required: true },
        noBorder: { type: Boolean, default: false },
    },
    computed: {
        borderClass: function () {
            if (this.noBorder) {
                return 'border-b-0';
            }
            return 'border-b border-a-brown-f5ebdc';
        },
    },
    methods: {
        trackingProcess:function(){
            let path = this.url;
            switch (path) {
                // Account Setting
                case '/deliveryaddress':
                    this.tracking.event('moremenu','click_address');
                    break;

                case '/card':
                    this.tracking.event('moremenu','click_creditcard');
                    break

                case '/taxaddress':
                    this.tracking.event('moremenu','click_taxinvoice');
                    break

                case '/favorite':
                    this.tracking.event('moremenu','click_my_favorite');
                    break

                case '/changepass':
                    this.tracking.event('moremenu','click_change_mobile_pin');
                    break

                //App Setting

                case '/store':
                    this.tracking.event('moremenu','click_find_store');
                    break

                case '/contact':
                    this.tracking.event('moremenu','click_contact_us');
                    break

                case '/terms':
                    this.tracking.event('moremenu','click_termandcondition');
                    break

                case '/privacy':
                    this.tracking.event('moremenu','click_privacy');
                    break

                default:
                    break;
            }
        }
    },
}
</script>
<style lang="scss" scoped>
    .icon-arrow {
        height: 11px;
    }
</style>
